import { lStorage } from "utils/storage";
import toaster from "utils/toaster";
import { getKeyCloakRefreshToken, logout } from "utils/common";
import { userDoesNotExists } from "utils/login";

const interceptor = (ax) => {
  ax.interceptors.request.use(
    async (config) => {
      const authInfo = lStorage.get("authInfo");

      let authToken = null;
      if (authInfo?.srcmToken) {
        try {
          authToken = await getKeyCloakRefreshToken();
        } catch {
          console.log("Something went wrong");
        }
        config.headers["Authorization"] = `Bearer ${
          authToken || authInfo.srcmToken
        }`;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  ax.interceptors.response.use(
    (next) => Promise.resolve(next),
    async (error) => {
      if (error.response && error.response.status === 401) {
        await logout();
      } else if (
        error.response &&
        error.response.status === 503 &&
        error.response.data.message &&
        error.response.data.message.toLowerCase().includes("user doesn't exist")
      ) {
        await userDoesNotExists();
      } else {
        toaster.custom({
          severity: "error",
          summary: "Error:",
          detail: error?.response?.data?.message || error.message,
        });
      }

      return Promise.reject(error);
    }
  );
};

export default interceptor;
